module.exports = __webpack_public_path__ + "static/media/WeShare.5c0c63fb.png";